<template>
  <v-layout>
    <v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3 xl4 offset-xl4>
      <slot />
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'responsive-layout',
  }
</script>
